import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { makeStyles } from '@material-ui/styles';

import { Box, Typography, Grid, Button } from '@material-ui/core';
import AuthCard from 'components/Cards/AuthCard';

const useStyles = makeStyles((theme) => ({
  instructions: {
    ...theme.typography.subtitle2,
  },
  title: {
    ...theme.typography.h5,
    marginBottom: theme.spacing(2),
    color: theme.palette.success.main,
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  footer: {
    display: 'flex',
    flexDirection: 'column',
  },
}));

const PasswordResetSuccess = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <AuthCard
      footer={
        <div className={classes.footer}>
          <Button size="small" component={Link} to="/Login">
            {t('return_to_login')}
          </Button>
        </div>
      }
    >
      <Grid container direction="row" justifyContent="space-evenly" spacing={4}>
        <Grid item xs={12}>
          <Box component="div" className={classes.root}>
            <Typography className={classes.title}>{t('password_reset_sucess')}</Typography>
          </Box>
        </Grid>
      </Grid>
    </AuthCard>
  );
};

export default PasswordResetSuccess;
